import React, { useEffect, useState } from 'react';
import { handleCallback } from '../services/auth';

function Callback() {
  const [error, setError] = useState(null);

  useEffect(() => {
    handleCallback()
      .then(() => {
        const dest = sessionStorage.getItem('postLoginRedirect') || '/';
        sessionStorage.removeItem('postLoginRedirect');
        // Full reload (not client-side nav) so the persistent nav bar
        // re-reads the freshly stored token and renders the signed-in state.
        window.location.replace(dest);
      })
      .catch((err) => {
        console.error('Auth callback failed:', err);
        setError(err.message || 'Sign-in failed');
      });
  }, []);

  if (error) {
    return (
      <div className="alert alert-danger mt-4">
        <p className="mb-2">Sign-in failed: {error}</p>
        <a href="/login" className="btn btn-sm btn-primary">Try again</a>
      </div>
    );
  }

  return (
    <div className="text-center mt-5">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Signing in...</span>
      </div>
      <p className="mt-3">Signing you in...</p>
    </div>
  );
}

export default Callback;
